import React from 'react';

import useSuccessNotificationsRemover from '../../../hooks/useSuccessNotificationsRemover';
import {getLocalizedStrings} from '../../../services/localization/localizationService';
import {ContentWrapper} from '../../Layout';
import {PopupFullPage} from '../../Popup';
import {Article} from '..';

const ErrorModalTemplate = (props) => {
    const {titleKey} = props;
    const localizedStrings = getLocalizedStrings();

    useSuccessNotificationsRemover();

    return (
        <PopupFullPage contentLabel={localizedStrings[titleKey]} {...props}>
            <ContentWrapper className='py-10 lg:pt-[88px]'>
                <Article error buttonsDirection='column' {...props} />
            </ContentWrapper>
        </PopupFullPage>
    );
};

export default ErrorModalTemplate;
